export default __webpack_public_path__ + "static/media/Renitta.06cefb74.png";